import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const SkillCard = ({ skill, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-40px' });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 24, scale: 0.95 }}
      animate={isInView ? { opacity: 1, y: 0, scale: 1 } : {}}
      transition={{ duration: 0.35, delay: index * 0.04, ease: 'easeOut' }}
      className="group relative"
    >
      {/* Glow on hover */}
      <div className="absolute -inset-px rounded-xl bg-gradient-to-br from-violet-500/30 to-cyan-500/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 blur-sm" />

      <div className="relative flex flex-col items-center justify-center p-4 rounded-xl bg-slate-800 border border-slate-700 group-hover:border-violet-500/40 transition-all duration-300 h-full">
        <div className="w-10 h-10 mb-3 transform transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3">
          <img
            src={`${process.env.PUBLIC_URL}/${skill.icon}`}
            alt={skill.name}
            className="w-full h-full object-contain"
          />
        </div>
        <p className="text-xs font-medium text-slate-400 group-hover:text-slate-200 transition-colors duration-300 text-center leading-tight">
          {skill.name}
        </p>
      </div>
    </motion.div>
  );
};

const Skills = () => {
  const titleRef = useRef(null);
  const titleInView = useInView(titleRef, { once: true });

  const skills = [
    { name: 'JavaScript', icon: 'js.svg' },
    { name: 'React', icon: 'logo512.png' },
    { name: 'Next.js', icon: 'nextjs-icon.svg' },
    { name: 'TypeScript', icon: 'typescript.svg' },
    { name: 'Python', icon: 'Python-logo-notext.svg' },
    { name: 'Django', icon: 'django.svg' },
    { name: 'Tailwind CSS', icon: 'Tailwind_CSS_Logo.svg' },
    { name: 'HTML', icon: 'html-5-logo.svg' },
    { name: 'CSS', icon: 'CSS3_logo.svg' },
    { name: 'SQL', icon: 'sql.png' },
    { name: 'AWS', icon: 'Amazon_Web_Services_Logo.svg' },
    { name: 'Jenkins', icon: 'jenkins.png' },
    { name: 'Playwright', icon: 'playwright-logo.svg' },
    { name: 'Selenium', icon: 'selenium-svgrepo-com.svg' },
    { name: 'Cucumber', icon: 'cucumber.svg' },
    { name: 'GitHub', icon: 'github.png' },
    { name: 'Langfuse', icon: 'langfuse.png' },
    { name: 'LangGraph', icon: 'langgraph.png' },
    { name: 'MCP', icon: 'mcp.png' },
    { name: 'Snowflake', icon: 'snowflake.png' },
  ];

  return (
    <section className="py-24 px-6 bg-slate-900" id="skills">
      <div className="max-w-5xl mx-auto">
        <motion.div
          ref={titleRef}
          initial={{ opacity: 0, y: 20 }}
          animate={titleInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-violet-400 text-xs font-semibold tracking-[0.2em] uppercase mb-3">
            Expertise
          </p>
          <h2 className="text-4xl font-bold text-slate-100 mb-4">Tech Stack</h2>
          <div className="w-16 h-px bg-gradient-to-r from-violet-500 to-cyan-400 mx-auto" />
        </motion.div>

        <div className="grid grid-cols-4 gap-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-7">
          {skills.map((skill, index) => (
            <SkillCard key={index} skill={skill} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
